import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import type {
    SttCorrectResponse,
    SttExtractFromEmailResponse,
    SttMailInput,
} from "../../managers/stt/types/stt";

export type SpeechToText = {
    correctText: (
        text: string,
        contextTags?: string,
    ) => Promise<SttCorrectResponse>;
    extractFromEmail: (
        mail: SttMailInput,
    ) => Promise<SttExtractFromEmailResponse>;
};

export function useSpeechToText(): SpeechToText {
    const { sttManager } = useSdk();

    return useMemo<SpeechToText>(
        () => ({
            correctText: (...args) => sttManager.correctText(...args),
            extractFromEmail: (...args) => sttManager.extractFromEmail(...args),
        }),
        [sttManager],
    );
}
